import {
  Breadcrumb,
  Checkbox,
  Dropdown,
  Input,
  Menu,
  Modal,
  Select,
} from 'antd';
import paths from 'pages/Router/paths';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  createRole,
  deleteRole,
  fetchRoles,
  modifyRole,
} from 'state/actions/roles';
import { fetchUsers } from 'state/actions/users';
import _ from 'underscore';
import RolesTable from './RolesTable';
import './Users.scss';

function Role() {
  const [search, setSearch] = useState('');
  const [selectedOrganization, setSelectedOrganization] = useState('All');
  const [data, setData] = useState([]);
  const [isModalShow, setIsModalShow] = useState(false);
  const [form, setForm] = useState({
    id: '',
    name: '',
    access: [],
  });

  const {
    roleList,
    loading,
    role,
    sites,
    organizations,
    success,
    created,
  } = useSelector(
    (state) => ({
      roleList: state.roles.list,
      userList: state.users.list,
      // isAdmin: state.auth.userData.isAdmin,
      error: state.roles.error,
      loading: state.roles.loading,
      deleted: state.roles.deleted,
      userData: state.auth.userData,
      role: state.auth.userData.role,
      sites: state.sites.list,
      organizations: state.organizations.list,
      success: state.roles.success,
      created: state.roles.created,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (role === 'admin' || role === 'superadmin') {
      dispatch(fetchUsers());
    }
  }, [dispatch, role]);

  useEffect(() => {
    if (success && !loading) {
      setIsModalShow(false);
      setForm({
        id: '',
        name: '',
        access: [],
      });
    }
  }, [success, loading]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (created) {
      dispatch(fetchRoles());
    }
  }, [created]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dispatch(fetchRoles());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (sites) {
      setData([
        ...data,
        ..._.sortBy(sites, 'name').map((site) => {
          return {
            id: site._id,
            title: site.name,
            key: site._id,
            site_id: site._id,
            organization_id: site.organizationId,
            children: [
              {
                key: `api-${site._id}`,
                organization_id: site.organizationId,
                id: `api-${site._id}`,
                parent_id: site._id,
                site_id: site._id,
                title: 'Arrival Landmark',
                module: 'arrival_landmark',
                children: [
                  {
                    key: `read-api-${site._id}`,
                    organization_id: site.organizationId,
                    id: `read-api-${site._id}`,
                    parent_id: `api-${site._id}`,
                    site_id: site._id,
                    title: 'Read Arrival Landmark',
                    module: 'arrival_landmark',
                    type: 'read',
                  },
                  {
                    key: `create-api-${site._id}`,
                    organization_id: site.organizationId,
                    id: `create-api-${site._id}`,
                    parent_id: `api-${site._id}`,
                    site_id: site._id,
                    title: 'Create Arrival Landmark',
                    module: 'arrival_landmark',
                    type: 'create',
                  },
                  {
                    key: `update-api-${site._id}`,
                    organization_id: site.organizationId,
                    id: `update-api-${site._id}`,
                    parent_id: `api-${site._id}`,
                    site_id: site._id,
                    title: 'Update Arrival Landmark',
                    module: 'arrival_landmark',
                    type: 'update',
                  },
                  {
                    key: `delete-api-${site._id}`,
                    organization_id: site.organizationId,
                    id: `delete-api-${site._id}`,
                    parent_id: `api-${site._id}`,
                    site_id: site._id,
                    title: 'Delete Arrival Landmark',
                    module: 'arrival_landmark',
                    type: 'delete',
                  },
                ],
              },
              {
                key: `poi-${site._id}`,
                organization_id: site.organizationId,
                id: `poi-${site._id}`,
                parent_id: site._id,
                site_id: site._id,
                title: 'Activity Pillar',
                module: 'activity_pillar',
                children: [
                  {
                    key: `read-poi-${site._id}`,
                    organization_id: site.organizationId,
                    id: `read-poi-${site._id}`,
                    parent_id: `poi-${site._id}`,
                    site_id: site._id,
                    title: 'Read Activity Pillar',
                    type: 'read',
                    module: 'activity_pillar',
                  },
                  {
                    key: `create-poi-${site._id}`,
                    organization_id: site.organizationId,
                    id: `create-poi-${site._id}`,
                    parent_id: `poi-${site._id}`,
                    site_id: site._id,
                    title: 'Create Activity Pillar',
                    type: 'create',
                    module: 'activity_pillar',
                  },
                  {
                    key: `update-poi-${site._id}`,
                    organization_id: site.organizationId,
                    id: `update-poi-${site._id}`,
                    parent_id: `poi-${site._id}`,
                    site_id: site._id,
                    title: 'Update Activity Pillar',
                    type: 'update',
                    module: 'activity_pillar',
                  },
                  {
                    key: `delete-poi-${site._id}`,
                    organization_id: site.organizationId,
                    id: `delete-poi-${site._id}`,
                    parent_id: `poi-${site._id}`,
                    site_id: site._id,
                    title: 'Delete Activity Pillar',
                    type: 'delete',
                    module: 'activity_pillar',
                  },
                ],
              },
            ],
          };
        }),
      ]);
    }
  }, [sites]); // eslint-disable-line react-hooks/exhaustive-deps

  const redirect =
    role === 'admin' || role === 'superadmin' ? (
      false
    ) : (
      <Redirect to={paths.ROOT} />
    );

  const columns = [
    {
      title: () => (
        <div className="search-permission">
          <input
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Start typing site name"
            className="search-permission-input"
          />
          <i className="feather-search icon-search-permission" />
        </div>
      ),
      dataIndex: 'title',
      key: 'title',
      width: 300,
      fixed: 'left',
    },
  ];

  const columnsPermission = roleList
    ? [
        ...columns,
        ...roleList.map((role) => {
          return {
            title: () => (
              <div className="permission-title">
                <div className="permission-title-content">
                  <p className="permission-title-text">Name</p>
                  <p className="permission-subtitle-text">{role.name}</p>
                </div>
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu.Item key="0" onClick={() => handleEdit(role._id)}>
                        <i className="feather-edit mr-1/5" />
                        Edit
                      </Menu.Item>
                      <Menu.Item
                        key="1"
                        onClick={() => onRemoveButtonClickHandler(role._id)}
                      >
                        <i className="feather-delete mr-1/5" />
                        Delete
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={['click']}
                >
                  <button className="permission-menu">
                    <i className="feather-more-vertical" />
                  </button>
                </Dropdown>
              </div>
            ),
            dataIndex: 'site_id',
            key: 'site_id',
            align: roleList.length > 4 ? 'center' : 'start',
            render: (site_id, record) => {
              const findAccess =
                role.access &&
                role.access.find((access) => access.siteId === site_id);

              if (record.module) {
                if (record.type) {
                  const allow = findAccess
                    ? findAccess[record.module][record.type]
                    : false;
                  return (
                    <Checkbox
                      onChange={(e) =>
                        handleAllow(
                          role._id,
                          site_id,
                          record.module,
                          record.type,
                          e.target.checked
                        )
                      }
                      checked={allow}
                    />
                  );
                } else {
                  const countChildren = record.children;
                  const totalChildren = findAccess
                    ? _.flatten(
                        countChildren.map((x) => findAccess[x.module][x.type])
                      )
                    : [];

                  const howManyTrueChildren = totalChildren.filter((x) => x);

                  return (
                    <Checkbox
                      onChange={(e) =>
                        handleAllowSome(
                          role._id,
                          site_id,
                          record.module,
                          e.target.checked
                        )
                      }
                      indeterminate={
                        howManyTrueChildren.length !== totalChildren.length &&
                        howManyTrueChildren.length > 0
                      }
                      checked={
                        howManyTrueChildren.length === totalChildren.length &&
                        findAccess
                      }
                    />
                  );
                }
              } else {
                const countChildren = record.children;
                const totalChildren = findAccess
                  ? _.flatten(
                      countChildren.map((x) =>
                        x.children.map((x) => findAccess[x.module][x.type])
                      )
                    )
                  : [];

                const howManyTrueChildren = totalChildren.filter((x) => x);

                return (
                  <Checkbox
                    onChange={(e) =>
                      handlAllowAll(role._id, site_id, e.target.checked)
                    }
                    indeterminate={
                      howManyTrueChildren.length !== totalChildren.length &&
                      howManyTrueChildren.length > 0
                    }
                    checked={
                      howManyTrueChildren.length === totalChildren.length &&
                      findAccess
                    }
                  />
                );
              }
            },
          };
        }),
      ]
    : columns;

  const handleSearch = (value) => {
    setSearch(value);
  };

  const handleChangeOrg = (value) => {
    setSelectedOrganization(value);
  };

  const handleAllow = (id, siteId, module, type, checked) => {
    const findRoleList = [...roleList].find((x) => x._id === id);
    const findAccess = [...findRoleList.access].find(
      (x) => x.siteId === siteId
    );
    if (findAccess) {
      if (findAccess[module]) {
        findAccess[module][type] = checked;
        dispatch(modifyRole(findRoleList, roleList));
      }
    } else {
      const allows = {
        arrival_landmark: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        activity_pillar: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
      };

      allows[module][type] = checked;
      allows.siteId = siteId;

      const newAccess = {
        ...findRoleList,
        access: findRoleList.access
          ? [...findRoleList.access, allows]
          : [allows],
      };
      dispatch(modifyRole(newAccess, roleList));
    }
  };

  const handleAllowSome = (id, siteId, module, checked) => {
    const findRoleList = [...roleList].find((x) => x._id === id);
    const findAccess = [...findRoleList.access].find(
      (x) => x.siteId === siteId
    );

    if (findAccess) {
      findAccess[module].create = checked;
      findAccess[module].delete = checked;
      findAccess[module].read = checked;
      findAccess[module].update = checked;

      //   console.log(findRoleList);
      dispatch(modifyRole(findRoleList, roleList));
    } else {
      const allows = {
        arrival_landmark: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
        activity_pillar: {
          create: false,
          read: false,
          update: false,
          delete: false,
        },
      };

      allows[module].create = checked;
      allows[module].delete = checked;
      allows[module].read = checked;
      allows[module].update = checked;
      allows.siteId = siteId;

      const newAccess = {
        ...findRoleList,
        access: findRoleList.access
          ? [...findRoleList.access, allows]
          : [allows],
      };

      //   console.log(newAccess, 'newAccess');
      dispatch(modifyRole(newAccess, roleList));
    }
  };

  const handlAllowAll = (id, siteId, checked) => {
    const findRoleList = [...roleList].find((x) => x._id === id);
    const findAccess = [...findRoleList.access].find(
      (x) => x.siteId === siteId
    );

    if (findAccess) {
      const accessMap = Object.keys(findAccess);
      accessMap.map((x) => {
        if (x !== 'siteId') {
          findAccess[x].create = checked;
          findAccess[x].delete = checked;
          findAccess[x].read = checked;
          findAccess[x].update = checked;
        }
        return null;
      });

      dispatch(modifyRole(findRoleList, roleList));
    } else {
      const allows = {
        arrival_landmark: {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        },
        activity_pillar: {
          create: checked,
          read: checked,
          update: checked,
          delete: checked,
        },

        siteId,
      };

      const newAccess = {
        ...findRoleList,
        access: findRoleList.access
          ? [...findRoleList.access, allows]
          : [allows],
      };
      dispatch(modifyRole(newAccess, roleList));
    }
  };

  const handleChangeInput = (name, value) => {
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleSubmit = () => {
    if (form.id) {
      dispatch(modifyRole(form, roleList));
    } else {
      dispatch(createRole(form));
    }
  };

  const handleEdit = (id) => {
    const findRole = roleList.find((x) => x._id === id);
    setForm({
      ...form,
      ...findRole,
      id,
    });
    setIsModalShow(true);
  };

  const handleCloseModal = () => {
    setForm({
      id: '',
      name: '',
      access: [],
    });
    setIsModalShow(false);
  };

  const onRemoveButtonClickHandler = (roleId) => {
    Modal.confirm({
      title: 'Are you sure want to delete this role?',
      content: 'Data cannot be restored after delete',
      onOk: () => dispatch(deleteRole(roleId)),
      okButtonProps: {
        loading,
      },
    });
  };

  return (
    <section className="users">
      {redirect}
      <Modal
        title={form.id ? 'Edit Role' : 'Add new Role'}
        visible={isModalShow}
        onCancel={handleCloseModal}
        okButtonProps={{
          loading,
        }}
        okText={form.id ? 'Save Changes' : 'Save'}
        onOk={handleSubmit}
      >
        <label style={{ marginBottom: '0.5em' }}>
          Role Name <span className="is-required">*</span>
        </label>
        <Input
          onChange={(e) => handleChangeInput('name', e.target.value)}
          required
          placeholder="eg: Administrator"
          value={form.name}
        />
      </Modal>
      <div className="header-content">
        <div className="header-left-content">
          <div className="breadcrumb-wrapper">
            <Breadcrumb>
              <Breadcrumb.Item>Home</Breadcrumb.Item>
              <Breadcrumb.Item className="breadcrumb-active">
                Roles
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <h1 className="page-title">Roles</h1>
        </div>
      </div>
      <div className="users__table">
        <div className="header-content">
          <div className="left-content">
            <label>Select Organization</label>
            <Select defaultValue="All" onChange={handleChangeOrg}>
              <Select.Option value="All">All Organization</Select.Option>
              {organizations &&
                organizations.map((organization) => {
                  return (
                    <Select.Option
                      value={organization._id}
                      key={organization._id}
                    >
                      {organization.name}
                    </Select.Option>
                  );
                })}
            </Select>
          </div>
          <button
            className="button-primary"
            onClick={() => setIsModalShow(true)}
          >
            <i className="feather-plus" />
            Add Roles
          </button>
        </div>
        <div className="table">
          <RolesTable
            data={data}
            columns={columnsPermission}
            search={search}
            selectedOrganization={selectedOrganization}
            loading={loading}
          />
        </div>
      </div>
    </section>
  );
}

export default Role;
